export default __webpack_public_path__ + "static/media/DFD-BUSD.7399c8fc.svg";